export default "__VITE_ASSET__CvnMLTGL__"